import {
  convertLabelMapToConfig,
  convertLabelUomMapToConfig,
  mergeConfig,
} from 'Components/Worksheets/Core/Helpers/configHelpers';

const portionLabelConfig = (prefix: string) =>
  convertLabelMapToConfig({
    [`${prefix}.SieveSize`]: `Fraction Retained on Sieve Size`,
    [`${prefix}.WashingSieve`]: `Wash Sieve`,
    [`${prefix}.GuardSieve`]: `Guard Sieve`,
    [`${prefix}.MeasuredConstantDryMass.DryingTray.DryMassReadings.DateTimeRemovedFromOvenLocal`]:
      'Date and Time Out of Oven',
  });

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      // PREPARATION
      [`${prefix}.Preparation.AggregateSizeFraction`]: `Aggregate Size Fraction`,
      [`${prefix}.Preparation.UseAdditionalSieve`]: `Determine mass passing extra 31.5mm sieve after fragmentation`,
      [`${prefix}.Preparation.IntermediateSieveSize`]: `Intermediate Sieve Size`,
      [`${prefix}.Preparation.IntermediateSieveSizeId`]: `Intermediate Sieve Size`,
      [`${prefix}.Preparation.Balance`]: `Balance`,
      [`${prefix}.Preparation.Oven`]: `Oven`,
      [`${prefix}.Preparation.DryingTemperature`]: `Oven Temperature`,
      [`${prefix}.Preparation.InitialSampleMass`]: `Initial Sample Mass`,

      // PREPARATION - Washed Coarse Portion Dry Mass
      [`${prefix}.Preparation.WashedCoarsePortion.MeasuredConstantDryMass.DryingTray.ConstantDrySoilMass`]: `Coarse Portion Dry Mass`,

      // PREPARATION - Washed Fine Portion Dry Mass
      [`${prefix}.Preparation.WashedFinePortion.MeasuredConstantDryMass.DryingTray.ConstantDrySoilMass`]: `Fine Portion Dry Mass`,

      // PREPARATION - Test Portion Mass
      [`${prefix}.Preparation.RecommendedCoarsePortionMass`]: `Recommended Coarse Portion Mass`,
      [`${prefix}.Preparation.CoarsePortionMass`]: `Coarse Portion Mass Selected`,
      [`${prefix}.Preparation.RecommendedFinePortionMass`]: `Recommended Fine Portion Mass`,
      [`${prefix}.Preparation.FinePortionMass`]: `Fine Portion Mass Selected`,
      [`${prefix}.Preparation.TotalPortionMass`]: `Total Test Portion Mass`,
      [`${prefix}.Preparation.RequiredPassingMassIntermediateSieve`]: `Required Mass Passing Intermediate Sieve`,
      [`${prefix}.Preparation.PassingMassIntermediateSieve`]: `Mass Passing Intermediate Sieve`,

      // MEASUREMENTS
      [`${prefix}.Measurements.Balance`]: `Balance`,
      [`${prefix}.Measurements.LAMachine`]: `L.A. Machine`,
      [`${prefix}.Measurements.NoOfBalls`]: `Number of Steel Spheres`,
      [`${prefix}.Measurements.MassOfBalls`]: `Mass of Steel Spheres`,
      [`${prefix}.Measurements.NoOfRevolutions`]: `Number of Revolutions`,
      [`${prefix}.Measurements.SeparationSieve`]: `Separation Sieve`,
      [`${prefix}.Measurements.RecoveredAggregateDryMassRetained`]: `Recovered Aggregate Dry Mass Retained`,

      // MEASUREMENTS - Coarse Portion Recovered Retained Aggregate
      [`${prefix}.Measurements.CoarsePortionRecoveredRetainedAggregate.MeasuredConstantDryMass.DryingTray.ConstantDrySoilMass`]: `Coarse Portion Dry Mass Retained`,

      // MEASUREMENTS - Fine Portion Recovered Retained Aggregate
      [`${prefix}.Measurements.FinePortionRecoveredRetainedAggregate.MeasuredConstantDryMass.DryingTray.ConstantDrySoilMass`]: `Fine Portion Dry Mass Retained`,

      // MEASUREMENTS - Material Retained on Extra Sieve
      [`${prefix}.Measurements.ExtraSieve.Code`]: `Sieve`,
      [`${prefix}.Measurements.ContainerMass_ExtraSieve`]: `Tare Mass`,
      [`${prefix}.Measurements.ContainerAndRetainedMass_ExtraSieve`]: `Tare and Retained Mass`,
      [`${prefix}.Measurements.RetainedMass_ExtraSieve`]: `Mass Retained`,

      // RESULTS
      [`${prefix}.Results.LosAngelesValue`]: `Los Angeles Coefficient`,
      [`${prefix}.Results.LosAngelesValue_31_5`]: `Los Angeles Coefficient (31.5)`,

      // RESULTS - Report
      [`${prefix}.Results.ReportSamplingProcedure`]: `Sampling procedure (BS EN 932-1)`,
      [`${prefix}.Results.ReportSampleReductionProcedure`]: `Sample reduction procedure (BS EN 932-2)`,
      [`${prefix}.Results.ReportTestPortionMass`]: `Test portion mass`,
      [`${prefix}.Results.ReportAggregateSizeFraction`]: `Aggregate size fraction`,
      [`${prefix}.Results.ReportSampleReceivedDate`]: `Sample received date`,
    }),

    // PREPARATION - Washed Coarse Portion Dry Mass
    portionLabelConfig(`${prefix}.Preparation.WashedCoarsePortion`),
    // PREPARATION - Washed Fine Portion Dry Mass
    portionLabelConfig(`${prefix}.Preparation.WashedFinePortion`),
    // MEASUREMENTS - Washed Recovered Retained Aggregate
    portionLabelConfig(`${prefix}.Measurements.WashedRecoveredRetainedAggregate`),
    // MEASUREMENTS - Coarse Portion Recovered Retained Aggregate
    portionLabelConfig(`${prefix}.Measurements.CoarsePortionRecoveredRetainedAggregate`),
    // MEASUREMENTS - Fine Portion Recovered Retained Aggregate
    portionLabelConfig(`${prefix}.Measurements.FinePortionRecoveredRetainedAggregate`),

    convertLabelUomMapToConfig({
      [`${prefix}.Preparation.RequiredPassingMassIntermediateSieve`]: '%',
      [`${prefix}.Preparation.PassingMassIntermediateSieve`]: '%',
      [`${prefix}.Preparation.AggregateSizeFraction`]: 'mm',
      [`${prefix}.Results.LosAngelesValue`]: '%',
      [`${prefix}.Results.LosAngelesValue_31_5`]: '%',
    })
  );

export default getLabelConfig;
